import React, {FC, ReactNode} from 'react';

// List Group Stuff

type ListGroupProps = {
  items: ReactNode[];
  className?: string;
};

export const ListGroup: FC<ListGroupProps> = ({items, className}) => {
  const tagListItems = items.map((item, i) => {
    return (
      <ListGroupItem key={i} index={i} totalCount={items.length}>
        {item}
      </ListGroupItem>
    );
  });

  return (
    <div className={`bg-white rounded-huge ${className || ''}`}>
      {tagListItems}
    </div>
  );
};

// List Group Item stuff

type ListGroupItemProps = {
  index: number;
  totalCount: number;
  onRemove?: () => void;
};

export const ListGroupItem: FC<ListGroupItemProps> = props => {
  const isFirst = props.index === 0;
  const isLast = props.index === props.totalCount - 1;

  const topRound = isFirst ? 'rounded-t-huge' : '';
  const bottomRound = isLast ? 'rounded-b-huge' : '';

  const separator = !isLast ? 'border-b' : '';

  return (
    <div
      className={`bg-white ${topRound} ${bottomRound} ${separator} hover:bg-gray-100`}
    >
      {props.children}
    </div>
  );
};
